export enum Operators {
  LTE = "lte",
  GTE = "gte"
}
